<template>

  <div id="app">
     <router-view />
     <redirect-modal v-if="redirectModal" />
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return{}
  },
computed: {
    redirectModal() {
      return this.$store.state.redirectModal;
    },
  },

  components: {
    RedirectModal
  },
  mounted() {
    if (localStorage.getItem('user')) {
      let token = JSON.parse(localStorage.getItem("user")).token;
      let refreshToken = JSON.parse(localStorage.getItem("user")).refreshToken;
       return axios({
        url: `${link.hostLink}Account/Refresh`,
        method: "post",
        data: { Token: token, RefreshToken: refreshToken },
      })
        .then((res) => {
        
            let user = JSON.parse(localStorage.getItem("user"));
            user.token = res.data.data.token;
            user.refreshToken = res.data.data.refreshToken;
            user.tokenExpiration = res.data.data.tokenExpiration;
            localStorage.setItem("user", JSON.stringify(user));
            this.$store.dispatch('setLogInFlag', true);

            
      })

    }
  },

}
import link from "@/scripts/host.js";
import axios from 'axios';
import RedirectModal from '@/components/RedirectModal/Desktop/RedirectModal.vue';
</script>

<style>
#app {

}
</style>
